import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { passwordCriteriaList } from './aux'
import { PasswordCriteriaTypes } from './types'
import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'

export const PasswordCriteria = ({
  password,
  setAllCriteriaMet,
  showErrorState,
}: PasswordCriteriaTypes) => {
  const { t } = useTranslation()

  // Cache translations
  const translations = useMemo(
    () => passwordCriteriaList.map(({ criteria }) => t(`signup.${criteria}`)),
    [t],
  )

  useEffect(() => {
    const allCriteriaMet = passwordCriteriaList.every(({ validate }) =>
      validate(password),
    )
    setAllCriteriaMet(allCriteriaMet)
  }, [password, setAllCriteriaMet])

  return (
    <BaseView gap={4} style={{ paddingBottom: 20 }}>
      {passwordCriteriaList.map(({ criteria, validate }, index) => {
        const isValid = validate(password)

        const getCriteriaColor = () => {
          if (isValid) return 'label.primary'
          if (showErrorState) return 'label.inputErrorMessage'
          return 'label.description'
        }

        return (
          <BaseView key={criteria} row align="center" gap={6}>
            <BaseText fontSize={16} color={getCriteriaColor()}>
              {translations[index]}
            </BaseText>
            {isValid && (
              <AppIcons name="check" size={18} color="icon.primary" />
            )}
          </BaseView>
        )
      })}
    </BaseView>
  )
}
